export default {
  state: {
    clientWidth: 0,
    offsetHeight: 0
  },
  mutations: {
    setClientWidth (state, val) {
      state.clientWidth = val
    },
    setOffsetHeight (state, val) {
      state.offsetHeight = val
    }
  },
  getters: {},
  actions: {
    globalInit ({ dispatch }) {
      dispatch('initClientWidth')
      dispatch('initOffsetHeight')
      window.addEventListener('resize', () => {
        dispatch('initClientWidth')
        dispatch('initOffsetHeight')
    })
    },
    initClientWidth ({ commit }) {
      commit('setClientWidth', document.body.clientWidth)
    },
    initOffsetHeight ({ commit }) {
      commit('setOffsetHeight', document.body.offsetHeight)
    }
  }
}